export enum FolderViewTypes {
    LIST = 'list',
    THUMB = 'thumb',
}
